// 引入外部工具函数
import * as Util from 'js/util/util.js'

/**
 * 重新装饰新的data
 */
function decorateData(res) {
  // 外层权限
  console.log(res)
  res.access_mode = Util.resolveFileAction(res.access_mode)
  res.content.forEach((content, index) => {
    // content.isfolder 解决与客户端判定文件夹的变量名不统一问题
    content.isfolder = content.isDir = content.is_dir
    // 先设置为false
    content.checked = false
    content.islocked = !!content.lock_uid
    content.access_mode = Util.resolveFileAction(content.access_mode)
    content.canPreivew = Util.suppportPreview(content)
    // content.unlockAdmin = (content.lock_uid == Util.getUserID()) || Util.isAdmin();
    content.data = [{
      type: 'file',
      showRename: false,
      get value() {
        return content.filename ? content.filename : content.path.split('/').pop()
      },
      fileMore: [],
      class: 'filelist-icon',
      others: '',
      showIconGroup: 'show',
      // operate: null,
      // custom: { // 自定义
      //     icon: 'icon-msg-forewarning'
      // },
    }, {
      get value() {
        // 默认列表模式
        let isListMode = true
        if (localStorage.getItem('Mode') != '' && localStorage.getItem('Mode') != undefined) {
          isListMode = localStorage.getItem('Mode') === 'list'
        }
        if (isListMode) {
          return `${Util.formatDate(content.modified, 'yyyy-MM-dd hh:mm')} | ${content.updator}`
        }
        return Util.formatDate(content.modified, 'yyyy-MM-dd hh:mm') + window.i18n.t(' 由<span title="{n}" class="update-creator">{n}</span>创建', { n: content.updator })
      },
      class: 'update-date-updator',
    }, {
      get value() {
        return content.is_dir ? '-' : Util.formatBytes(content.bytes)
      },
      class: 'update-size',
    }]
  })
  return res
}


/**
 * huangshuo
 * 获取完整的文件列表展示信息
 * @param linkData   //外联信息
 * @param callback  //回调函数
 * @returns {*}
 */
export function getFileList(linkData, callback) {
  // 装饰list
  const fileList = decorateData(linkData)
  // 吊用回调函数
  callback && callback(fileList)
}
